import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";

const Educationcs2 = () => {
    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);

  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url('/image/erp.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "46px", md: "70px" }}} mb={2}>
         
          On the Money Migration to Oracle Cloud ERP
          </Typography>
          <Typography variant="body1" sx={{ color: "white", fontSize: "18px" }}>
      Olds College wanted to implement its own cloud-based ERP system to improve control and efficiency of financial and procurement processes with better user experience and reduced operating costs.
          </Typography>
      <Typography variant="body1" sx={{ mt: 2, color: "white", fontSize: "18px"  }} mb={8}>
      The college partnered with Tech Informatic Solutions to migrate its financial systems from a solution managed by the University of Alberta to an Oracle Fusion Financials Cloud system.
          </Typography>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 10 }}>
     
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Business Needs
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        One universal thing that keeps leaders of organizations up at night: comprehensive and accurate financial management. And it’s not just managing funds and accounts, but also managing the data and processes associated with them. Many organizations rely on ERP systems as a core component of their financial management practice. The best systems are scalable, customizable and flexible enough to work across all financial functions — while also being cost-effective.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        For smaller organizations like Olds College, this need reverberates deeply. After five years of operating through an Oracle PeopleSoft ERP System hosted by the University of Alberta, Olds College decided to modernize their use of ERP. Partnering with Tech Informatic Solutions, it migrated a financial management system from University of Alberta’s PeopleSoft environment onto an Oracle Fusion Financials Cloud system. Together, they accomplished the migration in record time with no business disruption.
        </Typography>



         {/* outcome Section */}
       <Typography variant="h4" fontWeight="bold" mb={-12}>
         Outcomes
        </Typography>
       
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={8}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Implements Oracle Fusion ERP on an aggressive timeline with no business disruption",
                "Eliminates reliance on managed services through University of Alberta",
                "Improves overall efficiency, reporting and user experience",
                "Delivers 50% reduction in licensing costs",
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Migrates 750,000 financial records across the Olds College general ledger",
                "Increases accuracy and reduces audit risk by consolidating manual processes into Oracle system",
                "Migrates to a modern, cloud-based application for greater flexibility and customization",
            
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
                       <motion.div
                         whileHover={{ y: -5 }}
                         transition={{ type: "spring", stiffness: 200, damping: 10 }}
                         style={{ height: "90%" }} // 👈 ensure motion div stretches
                       >
                         <Box
                           sx={{
                             height: "100%", // 👈 make the card full height
                             position: "relative",
                             backgroundImage: `url(${feature.bgImage})`,
                             backgroundSize: "cover",
                             backgroundPosition: "center",
                             borderRadius: "12px",
                             p: 4,
                             display: "flex",
                             flexDirection: "column",
                             justifyContent: "space-between",
                             overflow: "hidden",
                             textAlign: "left",
                           }}
                         >


                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>


      <Container sx={{ py: 10 }}>
      
       
      <Typography  variant="h4" fontWeight="bold" mb={3}>
      Solution
          </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Graduating to the cloud
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Founded in 1913, Olds College specializes in agriculture, horticulture, land and environmental stewardship. One of Canada’s top 50 research colleges, its 544 faculty and staff members and 1,500 students are focused on “transforming agriculture for a better world.” In the summer of 2018, the Olds College Smart Farm, an exciting initiative that is transforming the college’s existing farm into a farm of the future was launched. By incorporating the latest technologies aimed at improving productivity, while efficiently and sustainably using resources, the Smart Farm is creating a cutting-edge learning environment for students and life-long learners.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        With Olds College’s contract with the University of Alberta nearing the end of its term, it was a good time to consider a move to a new system. Greg Wiens, CFO and director of business services, was interested in exploring what would be the next step. “We saw this as an opportunity to migrate to a leading-edge, cloud-based system that we could manage on our own. That would give us more control, flexibility, an improved user experience and better reporting as well as the ability to integrate some of our paper-based accounting processes that we couldn’t move into PeopleSoft.”
        </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Extra credit: the power of a good fit
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Finding the right partner was critical. Although they received proposals from several large IT solution providers who could provide the needed technical expertise, Tech Informatic Solutions stood out as the best fit. Tech Informatic Solutions not only came in with a very competitive bid and impressive technical expertise, but their approach included right-sizing the team to fit our culture — that was an important piece for us,” Wiens says.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        Working together towards an aggressive deadline, Olds College and Tech Informatic Solutions migrated from the PeopleSoft platform to the Oracle Fusion Financials System in 23 weeks with no siginificant business disruption.</Typography>
         <Typography variant="h5" fontWeight="bold" mb={3}>
         Accelerating sound solutions</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Managing the migration presented several challenges including a tight timeline and the complexity of migrating financial data with the added risk and time of transferring some data manually. Tech Informatic Solutions coded digital accelerators to automate the complex data migration and reduce errors. “The creation of the accelerators and the speed of implementation was impressive,” says Wiens. “Having experts that knew the data mapping from both a PeopleSoft perspective and a Fusion perspective was invaluable — we really couldn’t have done the project without Tech Informatic Solutions and those accelerator tools.”</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        As important as the technical piece was, it was equally important that both teams remained aligned at every step along the process. To achieve this, Tech Informatic Solutions implemented “Conference Room Pilots” — a series of incremental environment configurations to review design and development. This approach worked to keep the project on track and ensure milestones would be met.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        As the process unfolded, Wiens witnessed something unusual. “ERP projects are really challenging; you're up against deadlines, the workload is overwhelming and it’s easy for conflict to arise,” he explained. “That's one of the things I really appreciated about Tech Informatic Solutions — they remained collaborative problem solvers during difficult situations; there was no ‘us versus them’ mentality. That’s not always the case when you bring on consultants for this type of project.” </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        A bright financial future</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        After 23 weeks, the migration of Olds College’s ERP system to Oracle Fusion was complete, including transferring over 750,000 financial records across their general ledger.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        Along with eliminating their reliance on the University of Alberta, moving to Oracle Fusion sets Olds College up for success. The migration delivers a 50% reduction in licensing costs and provides all the functionality of PeopleSoft plus important additional benefits, including the ability to incorporate paper-based workflows that existed outside of PeopleSoft.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        The new system also improves user experience by enabling customizable screens, application bookmarks, graphical depictions of data and simplified expense approvals. “Oracle Fusion will significantly reduce risk and improve the efficiency, effectiveness and sustainability of our financial management processes,” says Wiens. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        Looking back on the migration, Wiens reflects, “Many ERP projects never make it through implementation, let alone deliver so close to the target date. The fact that Tech Informatic Solutions and our team collaborated really well and implemented the system within our aggressive timeline without significant negative impacts is amazing, and a pretty huge accomplishment in the ERP world.”</Typography>

</Container>



<Footer/>
    </Box>


  );
};

export default Educationcs2;
